<template>
  <div>
    <lang-toggle class='lang-toggle-fixed' variant='light' />
    <div>{{ $t('PathJSONを表示するにはEMARFアカウントのログインが必要です。') }}</div>
    <div>
      <input
        v-model="email"
        type="text"
        :placeholder="$t('メールアドレス')"
      />
    </div>
    <div>
      <input
        v-model="password"
        type="password"
        :placeholder="$t('パスワード')"
      />
    </div>
    <div>
      <button @click="onSubmit">{{ $t('ログイン') }}</button>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import LangToggle from '@/components/viewer/LangToggle.vue';

export default {
  name: 'Login',
  components: { LangToggle },

  data () {
    return {
      email: "",
      password: ""
    };
  },

  methods: {
    onSubmit () {
      Auth.signIn(this.email, this.password).then(() => {
        const redirect = this.$route.params.redirect || "/";
        this.$router.push(redirect);
      }).catch(error => {
        alert(error);
      });
    }
  }
};
</script>

<style scoped>
.lang-toggle-fixed {
  position: fixed;
  top: 12px;
  right: 16px;
  z-index: 9999;
  padding: 6px 10px;
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue